module.exports = __webpack_public_path__ + "img/f-8-1.ea93d566.png";